import { createRouter, createWebHistory } from 'vue-router'
import AdminLayout from '../layouts/AdminLayout.vue'
import BlogLayout from '../layouts/BlogLayout.vue'
import AdminArticleManageView from '../views/AdminArticleManageView.vue'
import AdminTagView from '../views/AdminTagView.vue'
import AdminUserView from '../views/AdminUserView.vue'
import AdminCommentManageView from '../views/AdminCommentManageView.vue'
import PostListView from '../views/blog/PostListView.vue'
import PostDetailView from '../views/blog/PostDetailView.vue'
import AboutView from '../views/blog/AboutView.vue'
import TagsView from '../views/blog/TagsView.vue'
import TagArticlesView from '../views/blog/TagArticlesView.vue'
import SearchView from '../views/blog/SearchView.vue'
import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { title: 'HwBlogs后台管理系统' }
  },
  {
    path: '/',
    component: BlogLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: PostListView,
        meta: { title: 'HwBlogs' }
      },
      {
        path: 'posts/:id',
        name: 'post-detail',
        component: PostDetailView,
        props: true,
        meta: { title: 'HwBlogs' }
      },
      {
        path: 'about',
        name: 'about',
        component: AboutView,
        meta: { title: 'HwBlogs' }
      },
      {
        path: 'tags',
        name: 'tags',
        component: TagsView,
        meta: { title: 'HwBlogs' }
      },
      {
        path: 'tags/:id',
        name: 'tag-articles',
        component: TagArticlesView,
        props: true,
        meta: { title: 'HwBlogs' }
      },
      {
        path: 'search',
        name: 'search',
        component: SearchView,
        meta: { title: 'HwBlogs' }
      }
    ]
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/articles',
    children: [
      {
        path: 'articles',
        name: 'admin-article-manage',
        component: AdminArticleManageView,
        meta: { title: 'HwBlogs后台管理系统' }
      },
      {
        path: 'tags',
        name: 'admin-tags',
        component: AdminTagView,
        meta: { title: 'HwBlogs后台管理系统' }
      },
      {
        path: 'users',
        name: 'admin-users',
        component: AdminUserView,
        meta: { title: 'HwBlogs后台管理系统' }
      },
      {
        path: 'comments',
        name: 'admin-comments',
        component: AdminCommentManageView,
        meta: { title: 'HwBlogs后台管理系统' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  const token = localStorage.getItem('token')

  // 已登录用户不允许进入 /login，统一回首页（保留 query，兜底 OAuth token 参数）
  if (to.path === '/login' && token) {
    next({ path: '/', query: to.query })
    return
  }

  if (to.path.startsWith('/admin')) {
    if (!token) {
      next({ path: '/login' })
    } else if (localStorage.getItem('userRole') !== '2') {
      sessionStorage.setItem('auth:notify', '无权限访问')
      window.dispatchEvent(new CustomEvent('auth:no-permission'))
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
